import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import type { TextFieldProps } from '@mui/material';

import type { Option } from '../types/form';

type SelectFieldProps = TextFieldProps & {
  options: Option[];
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function SelectField(props: SelectFieldProps) {
  const { options, validateIsNotEmpty = false, handleChange, handleBlur, ...rest } = props;
  const isSelectedOptionAvailable = options.some((o) => o.value === props.value);

  return (
    <TextField
      select
      fullWidth
      variant='standard'
      className={validateIsNotEmpty ? 'required' : ''}
      required={validateIsNotEmpty || false}
      onChange={(event) => handleChange(event.target.value)}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
      }}
      {...rest}
    >
      {!isSelectedOptionAvailable &&
        props.value !== undefined &&
        typeof props.value === 'string' &&
        props.value.trim().length > 0 && (
          <MenuItem value={props.value} disabled>
            {props.label || 'Eintrag'} gelöscht
          </MenuItem>
        )}

      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export type { SelectFieldProps };

export default SelectField;
